
export type GetHashtagByTagParams = {
/**
 * 페이지 번호
 */
page?: number;
/**
 * 페이지 크기
 */
size?: number;
};
